/** Why a window error was sent as a third-party warning instead of a crash, written on the warning as `rule`. */
export enum CrashRule {
	/** Code a browser or an extension ran inside the page document, not one of our files. */
	InjectedCode = 'injected-code',
}
